module.exports = JBrowseExports["@mui/material/SvgIcon"];